import { schema } from "normalizr";

const daysOff = new schema.Entity(`days_off`);
const arrayOfDaysOff = [daysOff];

export { daysOff, arrayOfDaysOff };
